import { apiRequest } from "../lib/apiClient";
import type { PromoCodeCreate, PromoCodeOut } from "./types";

/** `GET /promo-codes` — any authenticated user, excludes soft-deleted. */
export async function listPromoCodes(accessToken: string): Promise<PromoCodeOut[]> {
  return apiRequest<PromoCodeOut[]>("/promo-codes", { accessToken });
}

/** `GET /promo-codes/{code}` — lookup by exact code string, not id. */
export async function getPromoCode(accessToken: string, code: string): Promise<PromoCodeOut> {
  return apiRequest<PromoCodeOut>(`/promo-codes/${encodeURIComponent(code)}`, { accessToken });
}

/** `POST /promo-codes` — OWNER/BRANCH_MANAGER only. 409 if `code` already exists. */
export async function createPromoCode(accessToken: string, body: PromoCodeCreate): Promise<PromoCodeOut> {
  return apiRequest<PromoCodeOut>("/promo-codes", { method: "POST", accessToken, body });
}
